import { Toaster as Sonner, type ToasterProps } from "sonner"

/**
 * Sonner Toaster — renders toast notifications.
 * Place once at the app root level.
 *
 * On iOS (Capacitor), toasts are pushed up by --safe-area-bottom so they
 * don't overlap the home-indicator / gesture bar.
 *
 * When the FAB is visible (mobile, no-selection), --fab-toast-offset is set
 * by AddFab so toasts render above the FAB button.
 *
 * On desktop, the ActionPanel (59px) is always visible at the bottom, so the
 * default offset is 60px to keep toasts above it.
 */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-center"
      duration={5000}
      closeButton={false}
      style={{
        // Priority: --fab-toast-offset (mobile FAB visible, 72px) →
        // --action-panel-offset (desktop, 60px) → safe-area-bottom (native).
        // ActionPanel sets --action-panel-offset on :root when visible.
        bottom:
          "var(--fab-toast-offset, var(--action-panel-offset, var(--safe-area-bottom, 0px)))",
      }}
      toastOptions={{
        className:
          "!bg-card !text-foreground !border-border !shadow-lg !rounded-lg",
        actionButtonStyle: {
          backgroundColor: "var(--primary)",
          color: "var(--primary-foreground)",
        },
      }}
      {...props}
    />
  )
}
